const getModals = (state) => {
	return state.Session.modals;
};

export default getModals;
